import gpraStyles from "../../../styles/Participant-GPRA.module.css"
const FormLabel = (props) => {
  const { label, required } = props
  return (
    <div className={gpraStyles.formLabel}>
      <h4 className={required}>{label} {required && <span className={gpraStyles.required}>*</span>}</h4>
    </div>
  )
}
export default FormLabel
